var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright layout-row layout-hv-center color-white bg-pink1"},[_vm._v("\n\tCopyright © 2018 社團法人臺灣童心創意行動協會 | All Rights Reserved.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }